import { render, staticRenderFns } from "./Profimodel.vue?vue&type=template&id=6ea0f858&"
import script from "./Profimodel.vue?vue&type=script&lang=js&"
export * from "./Profimodel.vue?vue&type=script&lang=js&"
import style0 from "./Profimodel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports